export const interpolateErrorParams = (str: string, params?: Record<string, unknown>): string => {
  if (!params) return str;
  return str.replace(/{([^{}]*)}/g, (match, key: string) => {
    const value = params[key];
    return value !== undefined && value !== null ? String(value) : match;
  });
};
